<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="!loaded ? '' : (cameFromAssignPro ? ('Add & Assign Pro' | translate) : ('Add Pro' | translate))"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form" style="height: 100%;">
    <tidy-wrapper>

      @if (loaded) {
        @if (!noAddressSelected) {
          @if (!address?.address_name) {
            <tidy-row [align]="'center'">
              <tidy-text
                [header]="'For'"
                [translate]="false" /><span>&nbsp;</span>
                <tidy-text
                  [header]="address?.address1"
                  [translate]="false" />
                <tidy-text
                  [header]="address?.address2 !== null ? ' ' + address?.address2 : ''"
                  [translate]="false" />
              </tidy-row>
            }
            @if (address?.address_name) {
              <tidy-row [align]="'center'">
                <tidy-text
                  [header]="'For'"
                  [translate]="false" /><span>&nbsp;</span>
                  <tidy-text
                    [header]="address?.address_name"
                    [translate]="false" />
                </tidy-row>
              }
            }
            <tidy-alert>
              <tidy-card-button class="arrow-to-top" style="padding-bottom: 0px" (action)="goToAddConciergeTask()">
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/concierge.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="'Have Concierge Add For Me'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'We typically get this done in 1 business day, and email you back!'" />
                </tidy-row>
              </tidy-card-button>
            </tidy-alert>
            <tidy-card>
              @if (hasOtherPros && !noAddressSelected) {
                <tidy-row>
                  <tidy-text
                    [header]="'Who would you like to add?'" />
                </tidy-row>
                <tidy-row>
                  <tidy-radio-button
                    formControlName="addType"
                    [form]="form.controls.addType"
                    [items]="addTypeItems"
                    (optionChange)="updateRequiredFields($event)" />
                </tidy-row>
                <tidy-row class="extra-top-padding extra-bottom-padding">
                  <tidy-divider />
                </tidy-row>
              }
              @if (!hasOtherPros || form?.controls?.addType?.value === 'new' || noAddressSelected) {
                @if (noAddressSelected) {
                  <tidy-row>
                    <tidy-text
                      [header]="'Where do you want to add this pro?'" />
                  </tidy-row>
                  <tidy-row [ngStyle]="{'margin-bottom': form?.value?.whereToAdd === 'select' ? '0px' : '-75px'}">
                    <tidy-radio-button
                      formControlName="whereToAdd"
                      [form]="form.controls.whereToAdd"
                      [items]="whereToAddItems" />
                  </tidy-row>
                  <tidy-row [ngStyle]="{'visibility': form?.value?.whereToAdd === 'select' ? 'visible' : 'hidden'}">
                    <tidy-select
                      #tidySelect
                      [icon]="'assets/svg/home.svg'"
                      [label]="'Select Properties'"
                      [items]="propertiesToAddItems"
                      [form]="form.controls.propertiesToAdd"
                      formControlName="propertiesToAdd"
                      [multiple]="true"
                      [submitted]="submitted"
                      [errorMessage]="'Please select at least one property.'" />
                  </tidy-row>
                  <tidy-row class="extra-top-padding extra-bottom-padding">
                    <tidy-divider />
                  </tidy-row>
                }
                <tidy-row class="extra-bottom-padding">
                  @if (!cameFromGetStartedPage) {
                    <tidy-text
                      [body]="'Add someone you work with to send them requests to do your jobs.'" />
                  }
                  @if (cameFromGetStartedPage) {
                    <tidy-text
                      [body]="'Add someone you work with that you want to use your'" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="creditBalance | tcurrency" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="'to pay.'" />
                      }
                      <span>&nbsp;</span>
                      <tidy-text
                        class="link"
                        [body]="'Learn More'"
                        (action)="learnMoreAddPros()" />
                    </tidy-row>
                    <tidy-row class="field-top-padding field-bottom-padding">
                      <tidy-input
                        formControlName="name"
                        [label]="'Their Name'"
                        [form]="form.controls.name"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a name.'"
                        [icon]="'assets/svg/person.svg'" />
                    </tidy-row>
                    <tidy-row class="field-bottom-padding">
                      <tidy-input
                        formControlName="email"
                        [label]="'Their Email'"
                        [form]="form.controls.email"
                        type="email"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a valid email.'"
                        [icon]="'assets/svg/mail.svg'" />
                    </tidy-row>
                    <tidy-row class="extra-bottom-padding">
                      <tidy-input-international-phone
                        formControlName="phone"
                        [label]="'Their Phone'"
                        [form]="form.controls.phone"
                        [inputMode]="'numeric'"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a valid phone.'"
                        [icon]="'assets/svg/phone-portrait.svg'"
                        [initialMask]="{ mask: '[00000000000000000000000]' }"
                        (countryCodeChange)="onCountryCodeChange($event)" />
                    </tidy-row>
                    <tidy-row>
                      <tidy-select
                        #tidySelect
                        [icon]="'assets/svg/briefcase.svg'"
                        [label]="'Services Offered'"
                        [items]="serviceCategoryItems"
                        [form]="form.controls.serviceCategories"
                        formControlName="serviceCategories"
                        [multiple]="true"
                        [submitted]="submitted"
                        [errorMessage]="'Please select at least one service.'" />
                    </tidy-row>
                  }
                  @if (form?.controls?.addType?.value === 'other' && !noAddressSelected) {
                    <tidy-row>
                      <tidy-select
                        #tidySelect
                        [icon]="'assets/svg/person.svg'"
                        [label]="'Select the Pro(s) to add'"
                        [items]="proItems"
                        [form]="form.controls.prosToAdd"
                        formControlName="prosToAdd"
                        [multiple]="true"
                        [submitted]="submitted"
                        [errorMessage]="'Please select at least one pro to add.'" />
                    </tidy-row>
                  }
                </tidy-card>
                @if (errorMessage) {
                  <tidy-error-message
                    [text]="errorMessage" />
                }
                <tidy-button
                  [text]="cameFromAssignPro ? 'Add & Assign Pro' : (form.value.prosToAdd?.length > 1 ? ('Add Pros' | translate) : ('Add Pro' | translate))"
                  [action]="boundSubmit"
                  class="primary" />
                <tidy-row [align]="'center'" class="extra-top-padding">
                  <tidy-text
                    [title]="'What Happens Next?'" />
                </tidy-row>
                @for (card of salesCards; track card; let last = $last; let first = $first) {
                  <tidy-alert style="padding: 15px 15px 15px 10px">
                    <tidy-grid>
                      <tidy-row>
                        <ion-row>
                          <ion-col size="2" class="vertical-align-center">
                            <div style="margin: auto">
                              <tidy-image
                                [src]="card?.image"
                                style="width:35px" />
                            </div>
                          </ion-col>
                          <ion-col>
                            <tidy-row>
                              <tidy-text
                                [header]="card?.title" />
                            </tidy-row>
                            <tidy-row>
                              <tidy-text
                                [body]="card?.text" />
                              @if (card?.title === 'We Can Help') {
                                <tidy-text
                                  [actionBody]="'Book Call'"
                                  class="link"
                                  (action)="goToBookCall()" />
                              }
                            </tidy-row>
                          </ion-col>
                        </ion-row>
                      </tidy-row>
                    </tidy-grid>
                  </tidy-alert>
                }
              }
            </tidy-wrapper>
          </form>
        </ng-template>

        @if (!isRightSideContent) {
          <app-scroll-wrapper [templateContent]="content" />
        }

        @if (isRightSideContent) {
          <ion-content class="ion-content-right-column">
            <ng-container *ngTemplateOutlet="content" />
          </ion-content>
        }
